import React from 'react';
import 'Lessons/angularModule';
import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const ShowStandaloneLessonDirective = angularDirectiveToReact('showStandaloneLesson', {
    lessonId: '<',

    // mode can be 'demo' or undefined
    mode: '<',
});

export const ShowStandaloneLessonComponent: React.FC = () => {
    const [key, params] = useAngularToReactRoute<{
        lessonId: string;
        mode?: string;
    }>();

    return <ShowStandaloneLessonDirective key={key} {...params} />;
};
